<template>
  <div class="main-content" id="panel">
    <!-- Header -->
    <!-- <Header /> -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <div class="row align-items-center py-4">
            <div class="col-lg-6 col-7">
              <h2>Edit Imported Data</h2>
              <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
                <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
                  <li class="breadcrumb-item">
                      <i class="fas fa-home"></i>
                  </li>
                  <li class="breadcrumb-item">
                    Data Aggregator
                  </li>
                  <li class="breadcrumb-item active" aria-current="page">Manage CUSIP</li>
                </ol>
              </nav>
            </div>
            <div class="col-lg-6 col-5 text-right"></div>
          </div>
          <!-- Card stats -->
        </div>
      </div>
    </div>
    <!-- Page content -->
    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="filter">
              <h3>FILTERED BY</h3>
              <form>
                <div class="form-group">
                  <label for="exampleFormControlInput1">CUSIP</label>
                  <input
                    type="text"
                    v-model="cusip"
                    class="form-control"
                    id="cusip"
                    placeholder="Enter CUSIP"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">PURPOSE</label>
                  <select class="form-control" id="purpose" v-model="purposeId">
                    <option value>Please select</option>
                    <option value="0">No Purpose</option>
                    <option
                      v-for="purpose in purposes"
                      :key="purpose.id"
                      v-bind:value="purpose.id"
                    >{{purpose.purpose}}</option>
                  </select>
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1">STATE</label>
                  <select class="form-control" id="purpose" v-model="stateId">
                    <option value>Please select</option>
                    <option value="0">No State</option>
                    <option
                      v-for="state in states"
                      :key="state.id"
                      v-bind:value="state.id"
                    >{{state.name}}</option>
                  </select>
                </div>
                <div class="text-center">
                  <button @click="filterCusipData()" type="button" class="btn btn-primary my-2">
                    FILTER
                    <i v-if="!loading" class="fas fa-filter"></i>
                    <i v-if="loading" class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                  </button>
                  <button
                    @click="clearFilter()"
                    v-if="stateId || cusip || purposeId || purposeId == '0'"
                    type="button"
                    class="btn btn-secondary my-2"
                  >CLEAR</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-12">
          <div class="card scrollbar" id="scroll">
            <div class="card-header bg-transparent">
              <div class="row align-items-center">
                <div class="col">
                  <h3>Manage CUSIP</h3>
                </div>
                <div class="text-center addCusip">
                  <button
                    type="button"
                    class="btn btn-primary my-2"
                    data-toggle="modal"
                    data-target="#addcusip"
                  >ADD CUSIP <i class="fas fa-plus-circle"></i></button>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover">
                <thead class="thead-light psticky">
                  <tr>
                    <th 
                      scope="col"
                      class="sort" 
                      v-bind:class="[sortOrder == 'asc' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'desc' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                      @click="sort('cusip')"
                    >Cusip</th>
                    <th 
                      scope="col" 
                      class="sort" 
                      v-bind:class="[sortOrder == 'asc' && sortColumn == 'state'  ? 'sort-asc' : '',sortOrder == 'desc' && sortColumn == 'state'  ? 'sort-desc' : '']"  
                      @click="sort('state')">State</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'asc' && sortColumn == 'purpose'  ? 'sort-asc' : '',sortOrder == 'desc' && sortColumn == 'purpose'  ? 'sort-desc' : '']"  
                      @click="sort('purpose')"
                    >Purpose</th>
                    <th 
                      scope="col"
                      class="sort" 
                      v-bind:class="[sortOrder == 'asc' && sortColumn == 'description'  ? 'sort-asc' : '',sortOrder == 'desc' && sortColumn == 'description'  ? 'sort-desc' : '']"  
                      @click="sort('description')"
                     >Description</th>
                    <th 
                      scope="col" 
                      class="sort" 
                      v-bind:class="[sortOrder == 'asc' && sortColumn == 'maturity_date'  ? 'sort-asc' : '',sortOrder == 'desc' && sortColumn == 'maturity_date'  ? 'sort-desc' : '']"  
                      @click="sort('maturity_date')"
                    >Maturity Date</th>
                    <th 
                      scope="col" 
                      class="sort" 
                      v-bind:class="[sortOrder == 'asc' && sortColumn == 'bond_insurer'  ? 'sort-asc' : '',sortOrder == 'desc' && sortColumn == 'bond_insurer'  ? 'sort-desc' : '']"  
                      @click="sort('bond_insurer')"
                    >Bond Insurer</th>
                    <th scope="col" >Action</th>
                  </tr>
                </thead>
                <tbody class="list">
                  <tr v-for="cusip in cusips" :key="cusip.id">
                    <td>{{cusip.cusip}}</td>
                    <td>
                      <span v-if="!cusip.editMode">{{getStateName(cusip.state_id)}}</span>
                      <select v-if="cusip.editMode" class="form-control" v-model="cusip.state_id">
                        <option value>Please select</option>
                        <option
                          v-for="state in states"
                          :key="state.id"
                          v-bind:value="state.id"
                        >{{state.name}}</option>
                      </select>
                    </td>
                    <td>
                      <span v-if="!cusip.editMode">{{getPurposeName(cusip.purpose_id)}}</span>
                      <select v-if="cusip.editMode" class="form-control" v-model="cusip.purpose_id">
                        <option value>Please select</option>
                        <option
                          v-for="purpose in purposes"
                          :key="purpose.id"
                          v-bind:value="purpose.id"
                        >{{purpose.purpose}}</option>
                      </select>
                    </td>
                    <td style="white-space:pre-wrap; word-wrap:break-word">{{cusip.description}}</td>
                    <td>{{cusip.maturity_date}}</td>
                    <td>{{cusip.bond_insurer}}</td>
                    <td>
                      <a
                        href="javascript:void(0);"
                        v-if="!cusip.editMode"
                        @click="cusip.editMode = true"
                      >
                        <span class="btn-icon">
                          <i class="fas fa-pen"></i>
                        </span>
                      </a>
                      <a href="javascript:void(0);" v-if="cusip.editMode">
                        <button
                          type="button"
                          class="btn btn-secondary btn-sm"
                          @click="cancelSave(currentPage,cusip)"
                        >Cancel</button>
                      </a>
                      <a href="javascript:void(0);" v-if="cusip.editMode">
                        <button
                          type="button"
                          class="btn btn-primary btn-sm"
                          @click="updateCusipdata(cusip)"
                        >Save</button>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getCusipData(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <!-- Modal Add Cusip -->
      <div
        class="modal fade"
        id="addcusip"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Cusip</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col">
                    <label for="inputEmail4">Enter CUSIP</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="addCusipObj.cusip"
                      placeholder="Enter Cusip"
                    />
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">Bond Insurer</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="addCusipObj.bondInsurer"
                      placeholder="Enter Bond Insurer"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col">
                    <label for="inputPassword4">Purpose</label>
                    <select class="form-control" id="purpose" v-model="addCusipObj.purposeId">
                    <option value="">Please select</option>
                    <option
                      v-for="purpose in purposes"
                      :key="purpose.id"
                      v-bind:value="purpose.id"
                    >{{purpose.purpose}}</option>
                  </select>
                  </div>
                  <div class="form-group col">
                    <label for="inputEmail4">Maturity Date</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="addCusipObj.maturityDate"
                      placeholder="Enter Cusip"
                    />
                  </div>
                  <div class="form-group col">
                    <label for="inputPassword4">State</label>
                    <select class="form-control"  v-model="addCusipObj.stateId" >
                    <option value="">Please select</option>
                    <option
                      v-for="state in states"
                      :key="state.id"
                      v-bind:value="state.id"
                    >{{state.name}}</option>
                  </select>
                  </div>
                </div>
                <div class="form-group form-row">
                  <label for="exampleFormControlTextarea1">Description</label>
                  <textarea class="form-control" v-model="addCusipObj.description" rows="3"></textarea>
                </div>
              </form>
            </div>
             <p v-if="errors.length">
                <ul>
                  <li class="alert alert-danger" role="alert" v-for="error in errors" v-bind:key="error">{{ error }}</li>
                </ul>
              </p>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">CANCEL</button>
              <button type="button" class="btn btn-primary" @click="addCusip()">ADD CUSIP</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Header from "../common/Header";
// import Footer from "../common/Footer";
import config from "@/config";
import stateConstants from "@/stateConstants";
// import DataTable from 'datatables'
/* eslint-disable no-unused-vars */

//import $ from "jquery";
//import this.$http from "this.$http";

export default {
  name: "viewdata",
  components: {
    // Header,
    // Footer
  },
  data() {
    return {
      accessToken: null,
      cusips: [],
      purposes: [],
      states: stateConstants,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      stateId: "",
      cusip: "",
      purposeId: "",
      sortColumn: "state",
      sortOrder: "asc",
      deleteCusipId: null,
      loading: false,
      addCusipObj: {
        cusip: "",
        maturityDate: "",
        description: "",
        bondInsurer: "",
        stateId: "",
        purposeId: ""
      },
      errors: []
    };
  },
  created() {},
  methods: {
    getStateName(stateId) {
      let obj = this.states.find(o => o.id === stateId) || {};
      return obj.name || " ";
    },
    getPurposeName(purposeId) {
      let obj = this.purposes.find(o => o.id === purposeId) || {};
      return obj.purpose || " ";
    },
    getCusipData(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      //console.log("token",this.accessToken)
      const auth = { headers: { authorization: this.accessToken } };
      this.$http
        .get(config.baseUrl + "/cusip/list?startAt=" +
            (currentPage * 10 - 10) +
            "&perPage=" +
            this.perPage +
            "&cusip=" +
            this.cusip +
            "&purposeId=" +
            this.purposeId +
            "&state_id=" +
            this.stateId +
            "&sortColumn=" +
            this.sortColumn +
             "&sortOrder=" +
            this.sortOrder+
             "&type=BID",
          auth
        )
        .then(result => {
          console.log(result);
          this.totalRows = result.data.count;
          result.data.data.forEach(function(element) {
            element.editMode = false;
            if (element.state_id === null) {
              element.state_id = "";
            }
            if (element.purpose_id === null) {
              element.purpose_id = "";
            }
          });
          this.cusips = result.data.data;
          this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          self.loading = false;
        });
    },
    filterCusipData() {
      //this.loading = true;
      this.getCusipData();
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'asc' ? this.sortOrder = "desc" : this.sortOrder = 'asc';
      this.getCusipData();

    },
    clearFilter() {
      this.cusip = this.stateId = this.purposeId = "";
      this.getCusipData();
    },
    cancelSave(currentPage, cusip) {
      cusip.editMode = false;
      this.getCusipData(currentPage);
    },
    addCusip() {
      let isValid = this.checkForm();
      if (isValid) {
        this.addCusipObj.stateId = "" + this.addCusipObj.stateId;
        this.addCusipObj.purposeId = "" + this.addCusipObj.purposeId;
        const auth = {
          headers: { authorization: this.accessToken }
        };
        this.$http
          .post(config.baseUrl + "/cusip", this.addCusipObj, auth)
          .then(response => {
            window.$("#addcusip").modal("hide");
            this.addCusipObj = {
                              cusip: "",
                              maturityDate: "",
                              description: "",
                              bondInsurer: "",
                              stateId: "",
                              purposeId: ""
                            }
          })
          .catch(e => {
            console.log(e.response);
            this.errors.push(e.response.data);
          });
      }
    },
    getPurposeList() {
      const auth = { headers: { authorization: this.accessToken } };
      this.$http.get(config.baseUrl + "/purpose/list", auth).then(result => {
        this.purposes = result.data.data;
      });
    },
    updateCusipdata(cusip) {
      const auth = {
        headers: { authorization: this.accessToken }
      };
      this.$http
        .put(
          config.baseUrl + "/cusip/" + cusip.id,
          {
            cusip: cusip.cusip,
            maturityDate: cusip.maturity_date,
            description: cusip.description,
            bondInsurer: cusip.bond_insurer,
            purposeId: cusip.purpose_id == "" ? null : cusip.purpose_id,
            stateId: cusip.state_id == "" ? null : cusip.state_id
          },
          auth
        )
        .then(response => {
          cusip.editMode = false;
        })
        .catch(e => {});
    },
    checkForm: function() {
      this.errors = [];
      if (
        this.addCusipObj.cusip &&
        this.addCusipObj.maturityDate &&
        this.addCusipObj.description &&
        this.addCusipObj.bondInsurer &&
        this.addCusipObj.stateId &&
        this.addCusipObj.purposeId
      ) {
        return true;
      }

      this.errors = [];

      if (!this.addCusipObj.cusip) {
        this.errors.push("Cusip number is required.");
        return false;
      }
       if (this.addCusipObj.cusip.length < 9) {
        this.errors.push("Enter 9 digit characters long  CUSIP");
        return false;
      }
       if (!this.addCusipObj.bondInsurer) {
        this.errors.push("BondInsurer is required.");
        return false;
      }
      if (!this.addCusipObj.purposeId) {
        this.errors.push("Purpose is required.");
        return false;
      }
      if (!this.addCusipObj.maturityDate) {
        this.errors.push("Maturity date is required.");
        return false;
      }
      if (!this.addCusipObj.stateId) {
        this.errors.push("State is required.");
        return false;
      }
      if (!this.addCusipObj.description) {
        this.errors.push("Description is required.");
        return false;
      }
     
     

    }
  },
  mounted(currentPage) {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getCusipData(currentPage);
        this.getPurposeList();
      }
    });
  }
};
</script>
<style scoped>
</style>